type OfficeHost = typeof Office.HostType[keyof typeof Office.HostType] | null;

/**
 * Maps an Office host to the channel slug Studio's settings API expects.
 * Defaults to "outlook" when host can't be resolved.
 */
export function hostToChannel(host: OfficeHost): string {
  if (host === Office?.HostType?.Word) return "word";
  if (host === Office?.HostType?.PowerPoint) return "powerpoint";
  return "outlook";
}
